import {Button, Modal, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {ApiUrl} from "../../../../auth/authMethods";
import BasicLoader from "../../../../component/BasicLoader/BasicLoader";
import displayAlertMsg from "../../../../component/AlertMsg/displayAlertMsg";
import SimulationData from "./SimulationData";
import LoadingButton from "@mui/lab/LoadingButton";
import DownloadIcon from '@mui/icons-material/Download';

export default function SimulationModal({
                                            openPreview, setOpenPreview,
                                            requestBody, error, setError
                                        }) {
    const [isLoading, setIsLoading] = useState(true);
    const [previewData, setPreviewData] = useState(null);

    const [isDownloading, setIsDownloading] = useState(false);

    console.log({requestBody})
    useEffect(() => {
        if (openPreview) {
            setError(false);
            setIsLoading(true);
            axios
                .post(`${ApiUrl}/antecipacoes/simulate`, requestBody)
                .then(function (response) {
                    setPreviewData(response.data)
                })
                .catch(function (error) {
                    console.log("Error: " + error);
                    if (error.response.status === 409) {
                        setError(displayAlertMsg(error.response.data.message));
                    }
                    if (error.response.status >= 500) {
                        setError(displayAlertMsg());
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [openPreview])


    const handleDownload = () => {

        setIsDownloading(true)

        const axiosConfig = {
            method: 'post',
            url: `${ApiUrl}/antecipacoes/simulate/export`,
            responseType: 'blob',
            data: previewData
        };

        // Realiza a requisição Axios
        axios(axiosConfig)
            .then(response => {
                // Cria um objeto URL para o blob
                const blobUrl = URL.createObjectURL(response.data);

                // Cria um link para download
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = 'simulacao-antecipacao.xlsx';

                // Adiciona o link ao corpo do documento
                document.body.appendChild(link);

                // Simula um clique no link para iniciar o download
                link.click();

                // Remove o link do corpo do documento após o download
                document.body.removeChild(link);
            })
            .catch(error => console.error('Erro ao gerar relatório:', error))
            .finally(() => {
                setIsDownloading(false)
            })
    }

    return <Modal
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        className="modal-xl d-flex align-items-center justify-content-center"
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
        centered
        style={{backgroundColor: 'rgba(0, 0, 0, 0.6)'}}
    >
        <Box
            width="80%"
            bgcolor="background.paper"
            borderRadius={8}
            boxShadow={24}
            p={4}
        >
            <Typography variant="h6" component="h2" gutterBottom>
                Simulação de antecipação
            </Typography>
            <Typography variant="body1" component="pre" style={{maxHeight: '60vh', overflow: 'auto'}}>
                {isLoading ?
                    <BasicLoader/> :
                    <>{(!!previewData) ?
                        <SimulationData previewData={previewData}/> :
                        <p className='text-danger'>
                            {(!!error) ?
                                error :
                                "Simulação indisponível no momento! " +
                                "Contate o suporte ou tente novamente mais tarde."
                            }
                        </p>
                    }</>
                }
            </Typography>
            <div className={'text-center'} style={{marginTop: '20px'}}>

                <Button
                    color={"success"}
                    variant={"contained"}
                    onClick={() => setOpenPreview(false)}
                    className='m-1'
                >
                    Voltar para Edição
                </Button>
                <LoadingButton
                    onClick={handleDownload}
                    loading={isDownloading}
                    loadingPosition="start"
                    startIcon={<DownloadIcon/>}
                    variant="contained"
                    className='m-1'
                >
                    <span>
                        &nbsp;Fazer Download
                    </span>
                </LoadingButton>
            </div>
        </Box>
    </Modal>
}